import type { FC, PropsWithChildren } from 'react';
import { Benefits } from '../benefits/Benefits';

type AccountLayoutProps = PropsWithChildren<{ showCreateAccountLink?: boolean }>;

export const AccountLayout: FC<AccountLayoutProps> = ({ showCreateAccountLink, children }) => (
    <div className="flex flex-col bg-white md:flex-row" data-testid="account-layout">
        <div className="flex flex-1 items-center justify-center">{children}</div>
        <div className="flex flex-1">
            <Benefits showCreateAccountLink={showCreateAccountLink} />
        </div>
    </div>
);

AccountLayout.defaultProps = {
    showCreateAccountLink: undefined,
};
